module.exports = __webpack_public_path__ + "img/advantage_01.01ddc8c7.jpg";